var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "CountTo",
    _vm._b(
      {
        attrs: {
          startVal: _vm.startVal,
          endVal: _vm.endVal,
          duration: _vm.duraction,
        },
      },
      "CountTo",
      _vm.attr,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }